import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function organizationReducer(
  state = initialState.organization,
  action
) {
  switch (action.type) {
    case types.ORGANIZATION_SERVICE_PLANS:
      return {
        ...state,
        internalOrgServicePlans: action.internalOrgServicePlans,
      };
    default:
      return state;
  }
}
